<template>
  <v-dialog
    width="600px"
    v-model="showDialogOnLeave"
  >
    <div class="dashboard-dialog-window">
      <div class="dashboard-dialog-window__message">
        {{ logout ?
          $ucfirst($t('login.logoutWithoutSaving' )) :
          (this.customLeaveMessage !== null ? this.customLeaveMessage : $ucfirst($t('login.leaveScreenWithoutSaving')))
        }}
      </div>
      <div class="dashboard-dialog-window__actions">
        <v-btn
          x-large
          text
          class="ml-4"
          @click="confirmLeave"
        >
          {{ $ucfirst($t('confirm')) }}
        </v-btn>
        <v-btn
          x-large
          text
          class="ml-4"
          @click="cancel"
          color="primary"
        >
          {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component UnsavedChangesWarning.vue
 *
 * @module UnsavedChangesWarning
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/UnsavedChangesWarning.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'UnsavedChangesWarning',
  props: {
    screen: {
      type: String,
      default: () => ''
    },
    customLeaveMessage: {
      type: [String, null],
      default: () => null
    },
    // check will be skipped and changes cleared when going to these screen
    targetScreensToSkip: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialogOnLeave: false,
      logout: false,
      nextRoute: null,
    };
  },
  computed: {
    ...mapGetters({
      unsavedChanges: 'patientSummary/unsavedChanges',
    }),
  },
  methods: {
    confirmLeave() {
      this.$store.dispatch('patientSummary/removeUnsaved');
      this.showDialogOnLeave = false;

      if (this.logout) {
        this.$app.eventBus.$emit('forceLogout');
      } else {
        this.$router.push({name: this.nextRoute});
      }
    },
    prepareToExit(to) {
      this.nextRoute = to;

      if (to === 'Login') {
        this.logout = true;
      } else if (this.targetScreensToSkip.includes(to)) {
        this.confirmLeave();
        return;
      }

      if (this.unsavedChanges(this.screen)) {
        this.showDialogOnLeave = true;
      }
    },
    logoutBeforeSave() {
      this.logout = true;
      this.showDialogOnLeave = true;
    },
    cancel() {
      this.showDialogOnLeave = false;
      this.logout = false;
    }
  },
  created() {
    this.$app.eventBus.$on('unsavedChangesBeforeLogout', this.logoutBeforeSave);
  },
  beforeDestroy(){
    this.$app.eventBus.$off('unsavedChangesBeforeLogout', this.logoutBeforeSave);
  },
}
</script>
